import React from "react";
import classNames from "classnames";

const StarIcon = ({ filled = false, className, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 24 24"
    fill={filled ? "currentColor" : "none"}
    stroke={filled ? "none" : "currentColor"}
    strokeWidth="1.8"
    strokeLinejoin="round"
    className={classNames("star-icon", filled ? "filled" : "empty", className)}
    {...props}
  >
    <polygon points="12 2 14.6 8.6 21.6 9 16.3 13.4 18 20.3 12 16.6 6 20.3 7.7 13.4 2.4 9 9.4 8.6" />
  </svg>
);

export default StarIcon;
